import { render } from "./index.vue?vue&type=template&id=dda0e3fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=dda0e3fa&lang=css"
import "./index.vue?vue&type=style&index=1&id=dda0e3fa&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=2&id=dda0e3fa&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda0e3fa"]])

export default __exports__